import { PropsWithChildren } from "react"

import {
  Button,
  Link,
  styled,
  useMediaQuery,
  useTheme,
  ButtonProps,
} from "@mui/material"

type BackButtonProps = {
  onClick?: () => void
  startIcon?: React.ReactNode
  "data-testid"?: string
}

const StyledBackButton = styled(Link)<ButtonProps>(({ theme }) => ({
  textDecoration: "none",
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  minHeight: 36,
  "&.MuiButton-root": {
    fontWeight: 600,
  },
  "> .MuiButton-startIcon": {
    marginRight: theme.spacing(0.75),
    [theme.breakpoints.up("md")]: {
      marginRight: theme.spacing(0.5),
    },
  },
  [theme.breakpoints.up("md")]: {
    minHeight: 40,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}))

const BackButton = ({
  onClick,
  startIcon,
  "data-testid": dataTestId,
  children,
}: PropsWithChildren<BackButtonProps>) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"))

  return (
    <StyledBackButton
      component={Button}
      color="secondary"
      startIcon={startIcon}
      onClick={onClick}
      data-testid={dataTestId}
      sx={{
        typography: isDesktop ? "body2" : "body3",
      }}
    >
      {children}
    </StyledBackButton>
  )
}

export default BackButton
